import React, { useState, useEffect } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useFormContext } from "react-hook-form";
import { masking, unmasking } from "../../../services/masking";

function ConfirmSmsConsent() {
  const Setting = useStoreState((state) => state.siteSettingsModel);
  const info = useStoreState((state) => state.applicantModel.applicant);
  const activeCheck = useStoreState((state) => state.siteSettingsModel.activateChecks); 

  const setInfo = useStoreActions(
    (actions) => actions.applicantModel.setApplicant
  );

  const [cursor, setCursorPosition] = useState(1);

  const {
    register,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  const getBankType = () => {
    return Setting.brandSettings.BankName === "Celtic Bank" ? "celtic" : "tbom";
  };

  useEffect(() => {
    if (info.PrimaryPhoneSms === info.PrimaryPhone) {
      clearErrors("PrimaryPhoneSms");
    }

    if (info.SecondaryPhoneSms === info.SecondaryPhone) {
      clearErrors("SecondaryPhoneSms");
    }
  }, [
    info.PrimaryPhoneSms,
    info.PrimaryPhone,
    info.SecondaryPhoneSms,
    info.SecondaryPhone,
    clearErrors,
  ]);

  return (
    <>
      <div className="col-12">
      <div className="col-12">
          <div className="row">
            <div className="form-check-label" htmlFor="smsConsent">
              I agree to receive transactional text messages such as alerts
              about my {Setting.brandSettings.ProductName} Mastercard<sup>®</sup> account.
              Message frequency will vary, and message and data rates may apply.
              Providing your consent is not required to obtain an account from
              the issuing bank. To opt-out at any time, reply "STOP" to
              any message, or call 1-866-449-4515. See the
              {" "}
              <a
                href={
                  Setting.webAssetsBaseUrlSettings.Cdn +
                  "pdf/terms/short_message_service_terms_of_use_" +
                  getBankType() +
                  ".pdf"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                Short Message Service (SMS) Terms of Use
              </a>{" "}
              and{" "}
              <a
                href={Setting.productSettings.OmpsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Online Mobile Privacy Statement
              </a>{" "}
              for more information. This opt-out does not apply to Fiserv 2Way
              Connect&#8480; related messages that I may be receiving.
            </div>
            <br />
          </div>
        </div>
        <div className="col-12">
        <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          <div className="input-container">
            <label htmlFor="PrimaryPhoneSms">
              Confirm your Primary Phone Number
            </label>
            <input
              value={masking(info.PrimaryPhone, "(XXX) XXX-XXXX")}
              onInput={(e) => {
                let value =
                  typeof e.nativeEvent.data === "undefined" ||
                  e.nativeEvent.data === null
                    ? e.target.value
                        .replaceAll("-", "")
                        .replaceAll("(", "")
                        .replaceAll(")", "")
                    : e.nativeEvent.data;
                if (
                  /[0-9]/.test(value) ||
                  e.nativeEvent.inputType === "deleteContentBackward"
                ) {
                  setInfo({
                    index: "PrimaryPhone",
                    value: unmasking(e, "(XXX) XXX-XXXX", info.PrimaryPhone),
                  });
                  setInfo({
                    index: "PrimaryPhoneSms",
                    value: unmasking(e, "(XXX) XXX-XXXX", info.PrimaryPhoneSms),
                  });
                }
              }}
              onKeyDown={(e) => {
                setCursorPosition(e.target.selectionStart);
              }}
              onKeyUp={(e) => {
                if (e.nativeEvent.key === "Backspace") {
                  e.target.setSelectionRange(cursor - 1, cursor - 1);
                }
              }}
              type="text"
              className="form-control"
              placeholder="(999) 999-9999"
              {...register("PrimaryPhoneSms")}
            />
          </div>
          {errors.PrimaryPhoneSms && (
            <span className="error-message">
              {" "}
              {errors.PrimaryPhoneSms.message}{" "}
            </span>
          )}
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
          <div className="input-container">
            <label htmlFor="SecondaryPhoneSms">
              Confirm your Secondary Phone Number
            </label>
            <input
              value={masking(info.SecondaryPhone, "(XXX) XXX-XXXX")}
              onInput={(e) => {
                let value =
                  typeof e.nativeEvent.data === "undefined" ||
                  e.nativeEvent.data === null
                    ? e.target.value
                        .replaceAll("-", "")
                        .replaceAll("(", "")
                        .replaceAll(")", "")
                    : e.nativeEvent.data;
                if (
                  /[0-9]/.test(value) ||
                  e.nativeEvent.inputType === "deleteContentBackward"
                ) {
                  setInfo({
                    index: "SecondaryPhone",
                    value: unmasking(e, "(XXX) XXX-XXXX", info.SecondaryPhone),
                  });
                  setInfo({
                    index: "SecondaryPhoneSms",
                    value: unmasking(
                      e,
                      "(XXX) XXX-XXXX",
                      info.SecondaryPhoneSms
                    ),
                  });
                }
              }}
              onKeyDown={(e) => {
                setCursorPosition(e.target.selectionStart);
              }}
              onKeyUp={(e) => {
                if (e.nativeEvent.key === "Backspace") {
                  e.target.setSelectionRange(cursor - 1, cursor - 1);
                }
              }}
              type="text"
              className="form-control"
              placeholder="(999) 999-9999"
              {...register("SecondaryPhoneSms")}
            />
          </div>
          {errors.SecondaryPhoneSms
            ? errors.SecondaryPhoneSms && (
                <span className="error-message">
                  {" "}
                  This field is missing or invalid. Please fill it correctly.{" "}
                </span>
              )
            : ""}
        </div>
        </div>
        </div>
        {
                !activeCheck && (
                    <div className='mt-3 terms-acknowledgements-checkbox'>
                        <div>
                            <input 
                                checked={info.SMSConsent === "1" ? true : false}
                                value={info.SMSConsent}
                                onClick={() => {
                                  setInfo({
                                    index: "SMSConsent",
                                    value: info.SMSConsent === "1" ? "0" : "1"
                                  })
                                }}
                                className="form-check-input" 
                                type="checkbox"
                                id="SMSConsent"
                                {...register("SMSConsent")}
                            />
                            <label className="form-check-label" >
                                I agree to the SMS Terms of Use
                            </label>
                        </div>
                        {errors.SMSConsent ? 
                            <div className="col-12 error-message"> You must acknowledge before continue. </div>
                            :
                            <></>
                        }
                    </div>
                )
            }
      </div>
    </>
  );
}

export default ConfirmSmsConsent;
